// Import JavaScript components
import "./components/accordion";
import "./components/accordion-menu";
import "./components/quick-search";
// import './components/tabs';
import "./components/toggle";
import "./components/menu";
import "./components/swiper";
import "./modules/parallax";
import "./modules/stat-counter";
import "./modules/timeline";
import "./modules/scrollable-image";
import "./modules/address-lookup";

// Setup LordIcon - <lord-icon> element
import lottie from "lottie-web";
import { defineElement } from "lord-icon-element";
defineElement(lottie.loadAnimation);

document.addEventListener("DOMContentLoaded", function () {
	const iconContainers = document.querySelectorAll(".card__icon-card, .card__icon-card-colored, .card__icon-card-contrast");
	const lordIcons = document.querySelectorAll("lord-icon");

	const observer = new IntersectionObserver(
		(entries, observer) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					const lordIcon = entry.target.querySelector("lord-icon");

					if (lordIcon) {
						if (!lordIcon?.player?.isPlaying) {
							lordIcon.player.playFromBeginning(); // Start the LordIcon animation
						}
					}
				}
			});
		},
		{ root: null, threshold: 0.5 } // Adjust the threshold as needed
	);

	iconContainers.forEach((iconContainer) => {
		observer.observe(iconContainer); // Observe each iconContainer individually
	});

	lordIcons.forEach((lordIcon) => {
		let computedColor = window.getComputedStyle(lordIcon).getPropertyValue("color"); // This returns a string like 'rgb(255, 255, 255)'

		// If the color is calculated out as white then it's likely on a dark background which means we'll want to make the icon white
		if (computedColor === "rgb(255, 255, 255)") {
			computedColor = computedColor.replace("rgb(", "").replace(")", "").replace(" ", "");

			const [r, g, b] = computedColor.split(",").map((val) => parseInt(val));
			const hex = ((r << 16) | (g << 8) | b).toString(16);
			const color = "#" + ("000000" + hex).slice(-6);

			lordIcon?.setAttribute("colors", "primary:" + color + ",secondary:" + color);
		} else {
			lordIcon?.setAttribute(
				"colors",
				"primary:" +
					window.tailwindConfig.themeColors("secondary").DEFAULT +
					",secondary:" +
					window.tailwindConfig.themeColors("accent").DEFAULT
			);
		}
	});
});

//If you want cookie consent
// import "./modules/cookie-consent";

//If you need a class to be toggled on a different element
// import "./modules/toggle";

//If you need to do something when its in/out of the viewport
// import "./modules/intersects";
